import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { AuthShell } from '@/components/templates/AuthShell';
import { Button } from '@/components/atoms/Button';
import { getConfig } from '@/lib/config';

export const Route = createFileRoute('/login')({ component: LoginPage });

function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const legacyDisabled = getConfig().features.legacyLoginPageDisabled;

  useEffect(() => {
    if (isAuthenticated && !isLoading) navigate({ to: '/' });
  }, [isAuthenticated, isLoading, navigate]);

  // F-G1: when the legacy page is disabled, skip the in-app card entirely and
  // bounce straight to Auth0 Universal Login. Flipping the flag back to false
  // restores the brand-styled card below (a true revert — FR-042).
  useEffect(() => {
    if (legacyDisabled && !isAuthenticated && !isLoading) {
      loginWithRedirect();
    }
  }, [legacyDisabled, isAuthenticated, isLoading, loginWithRedirect]);

  if (legacyDisabled) return null;

  return (
    <AuthShell>
      <h1 className="font-display text-title text-foreground">Welcome back</h1>
      <p className="mt-1 text-body-sm text-muted-foreground">
        Sign in to your GrowthCommons workspace.
      </p>
      <div className="mt-6 flex flex-col gap-3">
        <Button variant="primary" fullWidth onClick={() => loginWithRedirect()}>
          Sign in →
        </Button>
        <Button
          variant="tertiary"
          fullWidth
          onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}
        >
          Create account
        </Button>
      </div>
    </AuthShell>
  );
}
